<template>
  <div class="main-app-login">
    <div class="container">
      <div class="img-area">
        <img src="../assets/login-3.png" class="img" alt="" />
      </div>
      <div class="form-area">
        <div class="form">
          <p class="title">企业注册</p>
          <div class="sec-title">
            <span class="h2">欢迎加入</span>
            <span class="h2">AI分销</span>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="text"
              autofocus=""
              placeholder="请输入公司名称"
              @keyup.enter="register"
              @input="nameWarn = ''"
              v-model="form.name"
            />
            <div class="input-item-tip" v-if="nameWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              {{ nameWarn }}
            </div>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="text"
              autofocus=""
              placeholder="请输入手机号"
              @keyup.enter="register"
              @input="phoneWarn = ''"
              v-model="form.phone"
            />
            <div class="input-item-tip" v-if="phoneWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              {{ phoneWarn }}
            </div>
          </div>
          <div class="input-item">
            <input
              class="input"
              type="text"
              autofocus=""
              placeholder="请设置密码"
              @keyup.enter="register"
              @input="passwordWarn = ''"
              v-model="form.password"
            />
            <div class="input-item-tip" v-if="passwordWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              {{ passwordWarn }}
            </div>
          </div>
          <div class="input-item">
            <input
              class="input"
              autofocus=""
              @keyup.enter="register"
              placeholder="请输入短信验证码"
              v-model="form.code"
            />
            <div class="verification-code">
              <button class="button-min" @click="getCode" v-if="!getting">
                获取验证码
              </button>
              <button class="button-min" v-if="getting">
                重新获取 {{ time }}s
              </button>
            </div>

            <div class="input-item-tip" v-if="codeWarn">
              <img slot="prefix" src="../assets/cha.png" class="error" />
              {{ codeWarn }}
            </div>
          </div>
          <button
            class="input button-primary"
            type="primary"
            @click="register"
            @keyup.enter="register"
          >
            注册
          </button>
          <div class="register">
            <button class="button-login" type="primary" @click="login">
              <span style="color: #333333">已有账号？</span>立即登录
            </button>
          </div>
        </div>
        <div class="copyright">
          copyright© 2018-{{
            new Date().getFullYear()
          }}.布谷云软件技术(南京)有限公司<span style="margin-left: 10px"></span
          >联系电话：400-166-9695
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "register",
  data() {
    return {
      form: {
        name: "",
        password: "",
        phone: "",
        code: "",
      },
      nameWarn: "",
      passwordWarn: "",
      phoneWarn: "",
      codeWarn: "",
      bubuid: "",
      getting: false,
      time: 60,
      loading: false,
    };
  },
  methods: {
    login() {
      this.$router.push({
        name: "Login",
      });
    },
    register() {
      if (!this.loading && this.validation())
        this.$api.register({
          params: {
            // "ORIGIN_API": true,
            "USER.NAME": this.form.name,
            "USER.LOGIN_ID": this.form.phone,
            "USER.LOGIN_PASSWORD": this.form.password,
            APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
            APP_SOURCE: 2,
            SMS_CODE: this.form.code,
            $DEBUG: "6590udbu8648",
            // "EXPERIENCE_INFO": '',
            // "INVITE_CODE": this.getInviteCode(),
            // "CHANNEL": 20083
          },
          headers: {
            token: this.bubuid,
          },
          success: (res) => {
            alert("恭喜！注册成功，请等待服务专员联系");
            // this.$router.push("/");
            // this.goLogin();
            this.login();
          },
          fail: (res) => {
            if (res.msg) {
              if (res.msg.indexOf("验证码") !== -1) {
                this.codeWarn = res.msg;
              } else if (res.msg.indexOf("密码") !== -1) {
                this.passwordWarn = res.msg;
              } else if (res.msg.indexOf("公司") !== -1) {
                this.nameWarn = res.msg;
              } else {
                this.phoneWarn = res.msg;
              }
            }
          },
          complete: () => {
            this.loading = false;
          },
        });
    },
    goLogin() {
      this.$api.login({
        params: {
          // PHONE: this.form.account,
          // PWD: this.form.password,
          "USER.LOGIN_ID": this.form.phone,
          "USER.LOGIN_PASSWORD": this.form.password,
          APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
        },
        success: (res) => {
          let result = res.extraData;
          this.loginSuccess(result);
        },
        fail: (res) => {
          if (res && res.msg) {
            if (res.msg.indexOf("密码") !== -1) {
              this.passwordWarn = res.msg;
            } else {
              this.accountWarn = res.msg;
            }
          }
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    loginSuccess(result) {
      let bubuId = result.token;
      window.localStorage.setItem(
        "USER_TOKEN",
        bubuId.substr(bubuId.length - 32, 32)
      );
      let pathname;
      if (location.pathname.indexOf("login.html") !== -1) {
        pathname = location.pathname.replace("login.html", "index.html");
      } else {
        pathname = "/";
      }
      let url = location.origin + pathname + "#/data/operational/DataBoard";
      location.replace(url);
    },
    getInviteCode() {
      let date = new Date();
      let m = date.getMonth() + 1;
      let month = m >= 10 ? m : "0" + m;
      let d = date.getDate();
      let day = d >= 10 ? d : "0" + d;
      let h = date.getHours();
      let hour = h >= 10 ? h : "0" + h;
      return [month, day, hour].join("");
    },
    validation() {
      this.nameWarn = "";
      this.phoneWarn = "";
      this.codeWarn = "";
      this.passwordWarn = "";
      if (!this.form.name) {
        this.nameWarn = "公司名称不能为空";
        return false;
      }
      if (!this.form.phone) {
        this.phoneWarn = "手机号不能为空";
        return false;
      }
      if (!this.form.password) {
        this.passwordWarn = "密码不能为空";
        return false;
      }
      if (!this.form.code) {
        this.codeWarn = "验证码不能为空";
        return false;
      }
      return true;
    },
    getCode() {
      if (!this.getting) {
        if (this.form.phone.length != 11) {
          alert("请填写正确的手机号码");
        } else {
          this.getting = true;
          let dis = function (that) {
            setTimeout(() => {
              that.time--;
              if (that.time == 0) {
                that.getting = false;
                that.time = 59;
              } else {
                dis(that);
              }
            }, 1000);
          };
          dis(this);
          this.$api.getCode({
            params: Object.assign({}, this.getMd5Key(this.form.phone), {
              ORIGIN_API: true,
              PHONE: this.form.phone,
              APP_SOURCE: 2,
            }),
            success: (res) => {
              this.bubuid = res.extraData.bubuId;
            },
          });
        }
      }
    },
    getMd5Key(phone) {
      let time = new Date();
      let y = time.getFullYear();
      let m = time.getMonth() + 1;
      let d = time.getDate();
      let day = [y, m >= 10 ? m : "0" + m, d >= 10 ? d : "0" + d];
      let rdmKey =
        (parseInt((Math.random() + 1) * Math.pow(10, 8)) + "").substr(1, 8) +
        day.join("");
      return {
        RDM_KEY: rdmKey,
        SER_KEY: md5(phone + rdmKey + "data_808088"),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.error {
  position: absolute;
  top: 17%;
  left: -17%;
  width: 13px;
  height: 13px;
}
.main-app-login {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  .container {
    max-width: 1014px;
    min-width: 828px;
    width: 80%;
    height: 610px;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    // box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.1);
    .img-area {
      width: 428px;
      height: 610px;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .img {
        width: 602px;
        height: 546px;
        display: block;
        transform: translate(-50%, -50%);
        position: absolute;
        top: 56%;
        left: 45%;
      }
    }
  }
  .input-item {
    padding-bottom: 30px;
    position: relative;
  }
  .input {
    width: 360px;
    height: 52px;
    border-radius: 4px;
    border: 1px solid #f0f1f3;
    padding: 0 12px;
    font-size: 18px;
    outline-color: #f46c50;
    display: block;
  }
  .input-item-tip {
    position: absolute;
    top: 57%;
    left: 5%;
    margin-top: 10px;
    font-size: 14px;
    color: #f46c50;
    line-height: 18px;
  }
  .input-item-tip:before {
    content: "";
  }
  .form-area {
    position: absolute;
    min-width: 480px;
    height: 590px;
    background-color: #ffffff;
    right: 0;
    left: 568px;
    // top: 10%;
    bottom: 5%;
    box-shadow: 0px 8px 24px 0px rgba(240, 232, 232, 0.79);
    .form {
      width: 361px;
      transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 50%;
    }
    .copyright {
      position: absolute;
      bottom: -25px;
      left: 0;
      right: 0;
      text-align: center;
      color: #999999;
      font-size: 12px;
    }
    .verification-code {
      position: absolute;
      top: 5%;
      right: 5%;
    }
    .register {
      width: 100%;
      height: 15px;
    }
    input::-webkit-input-placeholder {
      position: relative;
      font-size: 18px;
      color: #999999;
    }
    .title {
      font-size: 30px;
      color: #333333;
      margin-top: 5px;
      margin-bottom: 15px;
    }
    .sec-title {
      margin-bottom: 30px;
    }
    .h2 {
      font-size: 16px;
      color: #666666;
    }
  }
  .button-primary {
    background: linear-gradient(
      to right,
      rgba(255, 142, 80, 1) 0%,
      #ff5c50 100%
    );
    font-size: 24px;
    text-align: center;
    color: #fff;
  }
  .button-primary:hover {
    opacity: 0.9;
  }
  .button-min {
    color: #ff5c50;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0);
    outline: none;
    border: none;
    padding: 10px;
    margin: 0 auto;
    display: inline-block;
  }
  .button-login {
    color: #ff5c50;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0);
    outline: none;
    border: none;
    padding-top: 22px;
    margin: 0 auto;
    display: inline-block;
  }
  .button-login:hover {
    cursor: pointer;
    color: #f97e3c;
  }
  .button-min:hover {
    cursor: pointer;
    color: #f97e3c;
  }
}
</style>
